import { storeActions } from '@/store/actions'
import { NotificationState } from '@/store/notifications/notification'
import { ActionReducerMapBuilder } from '@reduxjs/toolkit/react'
import { generateId } from '@repo/shared/uuid/uuid'

export function userCases(builder: ActionReducerMapBuilder<NotificationState>) {
  builder
    .addCase(storeActions.user.updatePassword.fulfilled, (state) => {
      state.all.push({
        createdAt: new Date().getTime(),
        descriptionTransKey: 'passwordUpdated',
        icon: 'check',
        id: generateId(),
      })
    })
    .addCase(storeActions.user.requestPasswordReset.fulfilled, (state) => {
      state.all.push({
        createdAt: new Date().getTime(),
        descriptionTransKey: 'passwordResetRequestSuccessDescription',
        titleTransKey: 'passwordResetRequestSuccess',
        icon: 'check',
        id: generateId(),
      })
    })
    .addCase(storeActions.user.requestPasswordReset.rejected, (state) => {
      state.all.push({
        createdAt: new Date().getTime(),
        descriptionTransKey: 'passwordResetRequestErrorDescription',
        titleTransKey: 'passwordResetRequestError',
        icon: 'warn',
        id: generateId(),
      })
    })
    .addCase(storeActions.user.resetPassword.fulfilled, (state) => {
      state.all.push({
        createdAt: new Date().getTime(),
        descriptionTransKey: 'passwordResetSuccess',
        titleTransKey: 'success',
        icon: 'check',
        id: generateId(),
      })
    })
    .addCase(storeActions.user.resetPassword.rejected, (state) => {
      state.all.push({
        createdAt: new Date().getTime(),
        descriptionTransKey: 'passwordResetFailure',
        titleTransKey: 'error',
        icon: 'warn',
        id: generateId(),
      })
    })
}
